import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-links-block',
  templateUrl: './skeleton-links-block.component.html',
  styleUrls: ['./skeleton-links-block.component.scss']
})
export class SkeletonLinksBlockComponent {}
